// extracted by mini-css-extract-plugin
var _1 = "N1a80zUk46tLadiSkk5b";
export { _1 as "storeItem" }
